import React, { useState } from 'react'
import { Box, Container, Stack, Link, SvgIcon, Typography, Card, CardHeader, CardContent, TextField, Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Logo } from '../../components/logo'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import ArrowLeftIcon from '@untitled-ui/icons-react/build/esm/ArrowLeft'
import { NavLink, Outlet, useLocation, useMatch } from 'react-router-dom'
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'
import LoadingButton from '@mui/lab/LoadingButton'

export function ForgotPassword() {

  const TOP_NAV_HEIGHT = 64

  const [adicionarEmailLoading, setAdicionarEmailLoading] = useState(false)

  const LayoutRoot = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top center',
    backgroundImage: 'url("/assets/gradient.svg")',
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    height: '100vh'
  }))

  const initialValues = {
    email: 'diassis0008@gmail.com',
  }
  
  const validationSchema = Yup.object({
    email: Yup
      .string()
      .email('É obrigatório um email válido')
      .max(255)
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, helpers) => {

      setAdicionarEmailLoading(true)

      const auth = getAuth()
      await sendPasswordResetEmail(auth, values.email).then(() => {
        setAdicionarEmailLoading(false)
      })
    }
  })

  return (
    <LayoutRoot>
      <Box
        component="header"
        sx={{
          left: 0,
          position: 'fixed',
          right: 0,
          top: 0,
          zIndex: (theme) => theme.zIndex.appBar
        }}
      >
        <Container maxWidth="lg">
          <Stack
            direction="row"
            spacing={2}
            sx={{ height: TOP_NAV_HEIGHT }}
          >
            <Stack
              alignItems="center"
              direction="row"
              display="inline-flex"
              spacing={1}
              sx={{ textDecoration: 'none' }}
            >
              <Box
                sx={{
                  display: 'inline-flex',
                  height: 24,
                  width: 24
                }}
              >
                <Logo />
              </Box>
              <Box
                sx={{
                  color: 'text.primary',
                  fontFamily: '\'Plus Jakarta Sans\', sans-serif',
                  fontSize: 14,
                  fontWeight: 800,
                  letterSpacing: '0.3px',
                  lineHeight: 2.5,
                  '& span': {
                    color: 'primary.main'
                  }
                }}
              >
                Devias Kit <span>PRO</span>
              </Box>
            </Stack>
          </Stack>
        </Container>
      </Box>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          flex: '1 1 auto'
        }}
      >
        <Container
          maxWidth="sm"
          sx={{
            py: {
              xs: '60px',
              md: '120px'
            }
          }}
        >
        <Box sx={{ mb: 4 }}>

        <NavLink to="/login">
          <Link
            color="text.primary"
            sx={{
              alignItems: 'center',
              display: 'inline-flex'
            }}
            underline="hover"
          >
            <SvgIcon sx={{ mr: 1 }}>
              <ArrowLeftIcon />
            </SvgIcon>
            <Typography variant="subtitle2">
              Login
            </Typography>
          </Link>
        </NavLink>

        </Box>
        <Card elevation={16}>
          <CardHeader
            sx={{ pb: 0 }}
            title="Esqueceu a senha?"
          />
          <CardContent>
            <form
              noValidate
              onSubmit={formik.handleSubmit}
            >
            <Typography
                color="text.secondary"
                variant="body2"
                sx={{
                  mt: -3
                }}
              >
              Será enviado para seu email um link para fazer a mudança de senha.
              </Typography>

              <TextField
                error={!!(formik.touched.email && formik.errors.email)}
                fullWidth
                sx={{
                  mt: 2
                }}
                helperText={formik.touched.email && formik.errors.email}
                label="Digite o seu email"
                name="email"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="email"
                value={formik.values.email}
              />
              <LoadingButton
                loading={adicionarEmailLoading}
                fullWidth
                size="large"
                sx={{ mt: 3 }}
                type="submit"
                variant="contained"
              >
                Enviar
              </LoadingButton>
            </form>
          </CardContent>
        </Card>
        </Container>
      </Box>
  </LayoutRoot>
  )
}
